import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { errorMessage, publicApi, unwrap } from "../api";
import { LegalLayout } from "./PrivacyPage";

/** The landing page, where people sign up again for a new link. */
const LANDING_URL: string = import.meta.env.VITE_LANDING_URL || "https://ten20.live";

/**
 * Public: the confirmation link emailed to someone who joined the early
 * access list on the landing page. Nothing changes until they press the
 * button (mail scanners only load the page).
 */
export function EarlyAccessPage() {
  const { token = "" } = useParams();
  const confirm = useMutation({
    mutationFn: async () => {
      const result = await publicApi.POST("/early-access/{token}/confirm", { params: { path: { token } } });
      if (!result.response.ok) unwrap({ ...result, data: undefined });
    },
  });
  return (
    <LegalLayout title="ten20 early access">
      {confirm.isSuccess ? (
        <>
          <p role="status">
            <strong>You&apos;re on the list!</strong> We&apos;ll email your invite as soon as ten20 is ready for your
            phone, before it opens to everyone.
          </p>
          <p>
            <a href={LANDING_URL}>Back to ten20</a>
          </p>
        </>
      ) : (
        <>
          <p>Confirm your email address to join ten20&apos;s early access list.</p>
          <div className="button-row">
            <button type="button" disabled={confirm.isPending} onClick={() => confirm.mutate()}>
              Confirm my email
            </button>
          </div>
        </>
      )}
      {confirm.error && (
        <p className="error" role="alert">
          {errorMessage(confirm.error, {
            404: "This link has expired or a newer one replaced it. Sign up again on ten20.live to get a new link.",
          })}
        </p>
      )}
    </LegalLayout>
  );
}
